import { uniqueId } from 'lodash-es';
import { GlFormGroup, GlFormInput, GlFormCharacterCount } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { n__, __ } from '~/locale';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { TITLE_LENGTH_MAX } from '../../issues/constants';
export default {
    name: 'WorkItemTitle',
    components: {
        GlFormGroup,
        GlFormInput,
        GlFormCharacterCount
    },
    directives: {
        SafeHtml
    },
    i18n: {
        titleLabel: __('Title (required)'),
        requiredFieldFeedback: __('A title is required')
    },
    props: {
        title: {
            type: String,
            required: true
        },
        titleHtml: {
            type: String,
            required: false,
            default: null
        },
        isEditing: {
            type: Boolean,
            required: false,
            default: false
        },
        isDetailPanel: {
            type: Boolean,
            required: false,
            default: false
        },
        isValid: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    emits: [
        'update-draft',
        'update-work-item'
    ],
    data () {
        return {
            inputId: uniqueId('work-item-title-')
        };
    },
    computed: {
        invalidFeedback () {
            return this.title ? '' : this.$options.i18n.requiredFieldFeedback;
        }
    },
    safeHtmlConfig: {
        ADD_TAGS: [
            'use',
            'gl-emoji'
        ]
    },
    methods: {
        overLimitText (count) {
            return n__('%d character over limit.', '%d characters over limit.', count);
        },
        emitField ($event) {
            this.$emit('update-draft', $event);
        },
        // Used in ./create_work_item.vue
        // eslint-disable-next-line vue/no-unused-properties
        focusInput () {
            this.$refs.workitemTitleField.focus();
        }
    },
    TITLE_LENGTH_MAX
};
